import tw from "tailwind-styled-components";

const ComingSoon = () => {


  return (
    <div className={`grid place-items-center h-screen`}>
      <Content>
        <div className="flex gap-2 mb-4 justify-center">
        <BlueTitle>{"Coming"}</BlueTitle>
        <Title>{"Soon"}</Title>
        </div>
        <Subtitle>We're working hard to bring something amazing!</Subtitle>
      </Content>
    </div>
  );
};

const Content = tw.div`text-center p-8 sm:p-12 max-w-xl w-full absolute top-1/3 left-1/2 transform -translate-x-1/2 -translate-y-1/2 justify-items-center`;
const BlueTitle = tw.h2`text-6xl font-bold text-primary-color`;
const Title = tw.h2`text-6xl font-bold text-gray-400`;
const Subtitle = tw.p`text-sm text-gray-500 justify-center content-center`;
export default ComingSoon;
